module.exports = __webpack_public_path__ + "img/bingo_ball-12.1eed8b67.png";